import React, { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import './sideBarKids.css'

export default function SidebarWomen({ filter, setFilter }) {
    const [isBrandOpen, setIsBrand] = useState(false);
    const [isPriceClick, setIsPriceClick] = useState(false);
    const [isOfferClick, setOfferClick] = useState(false);
    const [isFilterOption, setFilterOption] = useState(false)


    return <div className='sideBar'>
        <h5 className='sideBarHomeKids'>Home/Kids</h5>
        <h4  className='sideBarHomeKids'>Refine by</h4>
        <div className='sidebarOption'>
            <h5 className='sidebarOptionHeading'>More Filters <span className='sidebarButton'
             onClick={() => { setFilterOption(!isFilterOption) }}><span style={{fontSize:20}}>{isFilterOption ? <ArrowDropUpIcon /> : <ArrowDropDownIcon/>}</span></span></h5>
            {isFilterOption && <div> 
                <span className='sidebarButton' onClick={() => { setIsBrand(!isBrandOpen) }} >{isBrandOpen ? '-' : '+'} </span>
                <span className='sideBarHeading'>Brand</span>
                {isBrandOpen && <div><ul type="none" className='subFilterOption'>

                    <li><input type="checkbox" class="check_box" id="HELLCAT" checked={filter.brand && filter.brand == 'HELLCAT'}
                        onChange={() => { setFilter({ ...filter, brand: "HELLCAT" }) }} /> <span class="brand_space" value="HELLCAT"  >HELLCAT</span></li>

                    <li><input type="checkbox" class="check_box" id="H&M" checked={filter.brand && filter.brand == 'H&M'}
                        onChange={() => { setFilter({ ...filter, brand: "H&M" }) }} /> <span class="brand_space" value="H&M" >H&M</span></li>
                    <li><input type="checkbox" class="check_box" id="max" checked={filter.brand && filter.brand == 'max'}
                        onChange={() => { setFilter({ ...filter, brand: "max" }) }} /> <span class="brand_space" value="max" >max</span></li>
                    <li><input type="checkbox" class="check_box" id="Allen Solly Junior" checked={filter.brand && filter.brand == 'Allen Solly Junior'}
                        onChange={() => { setFilter({ ...filter, brand: "Allen Solly Junior" }) }} /> <span class="brand_space" value="Wrong" >Allen Solly Junior</span></li>

                    <li><input type="checkbox" class="check_box" id="CUTECUMBER" checked={filter.brand && filter.brand == 'CUTECUMBER'}
                        onChange={() => { setFilter({ ...filter, brand: "CUTECUMBER" }) }} /> <span class="brand_space" value="CUTECUMBER" >CUTECUMBER</span></li>

                    <li><input type="checkbox" class="check_box" id="Kool Kidz" checked={filter.brand && filter.brand == 'Kool Kidz'}
                        onChange={() => { setFilter({ ...filter, brand: "Kool Kidz" }) }} /> <span class="brand_space" value="Kool Kidz" >Kool Kidz</span></li>

                    <li><input type="checkbox" class="check_box" id="Crocs" checked={filter.brand && filter.brand == 'Crocs'}
                        onChange={() => { setFilter({ ...filter, brand: "Crocs" }) }} /> <span class="brand_space" value="Crocs" >Crocs</span></li>

                    <li><input type="checkbox" class="check_box" id="YK" checked={filter.brand && filter.brand == 'YK'}
                        onChange={() => { setFilter({ ...filter, brand: "YK" }) }} /> <span class="brand_space" value="YK" >YK</span></li>
                    
                    <li><input type="checkbox" class="check_box" id="Smily Kiddos" checked={filter.brand && filter.brand == 'Smily Kiddos'}
                        onChange={() => { setFilter({ ...filter, brand: "Smily Kiddos" }) }} /> <span class="brand_space" value="Smily Kiddos" >Smily Kiddos</span></li>
                    
                   
                    <li><input type="checkbox" class="check_box" id="HRX" checked={filter.brand && filter.brand == 'HRX'}
                        onChange={() => { setFilter({ ...filter, brand: "HRX" }) }} /> <span class="brand_space" value="HRX" >HRX</span></li>
                    
                    <li><input type="checkbox" class="check_box" id="DressBerry" checked={filter.brand && filter.brand == 'DressBerry'}
                        onChange={() => { setFilter({ ...filter, brand: "DressBerry" }) }} /> <span class="brand_space" value="DressBerry" >DressBerry</span></li>
                </ul>
                </div>
                }

                <hr />
                <span className='sidebarButton' onClick={() => { setIsPriceClick(!isPriceClick) }}>{isPriceClick ? '-' : '+'}</span>
                <span className='sideBarHeading'>Category</span>
                {isPriceClick && <ul type="none" className='subFilterOption'>
                    <li> <input type="checkbox" class="check_box" id="Boy-Tshirt" checked={filter.Category && filter.Category == 'Boy-Tshirt'} 
                    onChange={() => { setFilter({ ...filter, Category: "Boy-Tshirt" }) }} />
                        <span class="brand_space" >Boys-Tshirt</span><br /></li>

                    <li><input type="checkbox" class="check_box" id="Girls-Top" checked={filter.Category && filter.Category == 'Girls-Top'}
                        onChange={() => { setFilter({ ...filter, Category: "Girls-Top" }) }} /> <span class="brand_space" >Girls-Top</span></li>

                    <li><input type="checkbox" class="check_box" id="Boys-Shirt" checked={filter.Category && filter.Category == 'Boys-Shirt'}
                        onChange={() => { setFilter({ ...filter, Category: "Boys-Shirt" }) }} /> <span class="brand_space">Boys-Shirt</span></li>

                    <li><input type="checkbox" class="check_box" id="Girls-Dress" checked={filter.Category && filter.Category == 'Girls-Dress'}
                        onChange={() => { setFilter({ ...filter, Category: "Girls-Dress" }) }} /> <span class="brand_space">Girls-Dress</span></li>

                    <li><input type="checkbox" class="check_box" id="Watch" checked={filter.Category && filter.Category == 'Watch'}
                        onChange={() => { setFilter({ ...filter, Category: "Watch" }) }} /> <span class="brand_space">Watch</span></li>
                    <li><input type="checkbox" class="check_box" id="FlipFlop" checked={filter.Category && filter.Category == 'FlipFlop'}
                        onChange={() => { setFilter({ ...filter, Category: "FlipFlop" }) }} /> <span class="brand_space">FlipFlop</span></li>

                    <li><input type="checkbox" class="check_box" id="Shoes" checked={filter.Category && filter.Category == 'Shoes'}
                        onChange={() => { setFilter({ ...filter, Category: "Shoes" }) }} /> <span class="brand_space">Shoes</span></li>

                    <li><input type="checkbox" class="check_box" id="Bags" checked={filter.Category && filter.Category == 'Bags'}
                        onChange={() => { setFilter({ ...filter, Category: "Bags" }) }} /> <span class="brand_space">Bags</span></li>
                    
                    {/* <li><input type="checkbox" class="check_box" id="Sports-Outfit" checked={filter.Category && filter.Category == 'Sports-Outfit'}
                        onChange={() => { setFilter({ ...filter, Category: "Sports-Outfit" }) }} /> <span class="brand_space">Bags</span></li> */}
                </ul>
                }
                <hr />
                <span className='sidebarButton' onClick={() => { setOfferClick(!isOfferClick) }}>{isOfferClick ? '-' : '+'}</span>
                <span className='sideBarHeading'>Discount Range</span>
                {isOfferClick && <ul type="none" className='subFilterOption' >
                    <li> <input type="checkbox" class="check_box" id="10" checked={filter.Discount.first == 0 && filter.Discount.second == 20}
                    onChange={()=>{setFilter({...filter,Discount:{first : 0, second : 20}})}}/> <span class="brand_space">0-20%</span></li>

                    <li><input type="checkbox" class="check_box" id="20"  checked={filter.Discount.first == 20 && filter.Discount.second == 40 } 
                    onChange={()=>{setFilter({...filter,Discount:{first : 20, second : 40}})}}/> <span class="brand_space">20-40%</span></li>
                    
                    <li><input type="checkbox" class="check_box" id="30"  checked={filter.Discount.first == 40 && filter.Discount.second == 60} 
                    onChange={()=>{setFilter({...filter,Discount:{first : 40, second : 60}})}}/> <span class="brand_space">40-60%</span></li>

                    <li> <input type="checkbox" class="check_box" id="40"  checked={filter.Discount.first == 60 && filter.Discount.second == 80 } 
                    onChange={()=>{setFilter({...filter,Discount:{first : 60, second : 80}})}} /> <span class="brand_space">60-80%</span></li>

                    {/* <li><input type="checkbox" class="check_box" id="50" /> <span class="brand_space">50% and above</span></li> */}
                </ul>
                }
            </div>
            }


        </div>
    </div>
}